

export default function NoPage() {
    return (
        <div>
            <div className="py-20">
                <h1 className="text-[10rem] font-black main-color text-center">404</h1>
                <p className="text-center text-xl">
                    Oops sorry we can&apos;t find that page!
                </p>
            </div>
        </div>
    );
}
